import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const Share = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M7 14a2 2 0 10.001-3.999A2 2 0 007 14zm9-5a2 2 0 10.001-3.999A2 2 0 0016 9zm0 10a2 2 0 10.001-3.999A2 2 0 0016 19zM14.252 7.971L8.748 11.03m0 1.942l5.504 3.058"
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    />
  </svg>
)
